<template>
    <div>
        <div style="width: 85%; margin: auto; display: flex; justify-content: space-around; flex-wrap: wrap;">
            <md-field class="md-toolbar-section-end" style="margin-right : 40px; max-width: 160px;">
                <md-select v-model="presetCategory" @md-selected="fetchPanelPresets">
                    <md-option value="personal">
                        Personal
                    </md-option>
                    <md-option value="community">
                        Community
                    </md-option>
                </md-select>
            </md-field> 
            <md-field md-clearable class="md-toolbar-section-end">
                <md-input placeholder="Search for presets" v-model="presetSearchTerms"/>
            </md-field>
        </div>
        <div style="height: 50vh; overflow-y: scroll; border: 1px #ddd solid;">
            <table class="preset-table">
                <tr v-for="(presetEntry, presetIndex) in searchResults" :key="presetIndex">
                    <td style="border-right: 1px dotted black;" v-if="addLabsMode">
                        <md-checkbox v-model="presetsToAdd" :value="presetEntry.id"></md-checkbox>
                    </td>
                    <td style="border-right: 1px dotted black;" v-else>
                        #{{presetIndex+1}}
                    </td>
                    <td v-if="addLabsMode">
                        <span>
                        <a :href="'/panel_presets/' + presetEntry.id" target="_blank">
                            {{presetEntry.panel.name}} ({{presetEntry.abnormality ? presetEntry.abnormality : "Normal"}})
                        </a>
                        </span>
                    </td>
                    <td v-else>
                        <router-link :to="'/settings/panel_presets?presetID=' + presetEntry.id">
                            {{presetEntry.panel.name}} ({{presetEntry.abnormality ? presetEntry.abnormality : "Normal"}})
                        </router-link>
                    </td>
                    <td style="border-left: 1px dotted black;">
                        <div style="display: flex; justify-content: center; padding: 0 10px;">
                            <span :class="{'active-vote': presetVotes[presetEntry.id].myVote == 'up'}"
                            v-if="presetVotes[presetEntry.id]" style="white-space: nowrap;">
                                <i class="fas fa-thumbs-up"></i>&nbsp;&nbsp;{{presetVotes[presetEntry.id].counts["up"]}}
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <span :class="{'active-vote': presetVotes[presetEntry.id].myVote == 'down'}"
                            v-if="presetVotes[presetEntry.id]" style="white-space: nowrap;">
                                <i class="fas fa-thumbs-down"></i>&nbsp;&nbsp;{{presetVotes[presetEntry.id].counts["down"]}}
                            </span>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <br><br>
        <center>
            <md-button v-if="addLabsMode" @click="addPresetsToSlide"
            class="md-raised md-primary" style="min-width: 300px;">
                Add Presets to Slide
            </md-button>
            <md-button v-else @click="createNewPreset"
            class="md-raised md-primary" style="min-width: 300px;">
                Create New Preset
            </md-button>
        </center>
        <PanelPresetEditor @fetchPanelPresets="fetchPanelPresets(true)"/>
    </div>
</template>

<script>
    import APIRequests from "./APIRequests.js"
    import PanelPresetEditor from "./editors/PanelPresetEditor.vue"
    const ObjectID = require("bson-objectid");
    import Fuse from "fuse.js"

    export default {
        props: {
            addLabsMode: {
                type: Boolean   
            }
        },
        data: function(){
            return {
                panelPresets: {},
                presetCategory: "personal",
                presetVotes: {},
                searchResults: [],
                presetsToAdd: [],
                presetSearchTerms: "",
            }
        },
        components: {
            PanelPresetEditor,
        },
        watch: {
            presetSearchTerms: function(){
                this.searchPresets()
            },
            presetCategory: function(){
                this.presetsToAdd = []
            }
        },
        methods: {
            searchPresets: function(){
                let searchable = Object.values(this.panelPresets[this.presetCategory])
                if(this.presetSearchTerms.trim() == ""){
                    this.searchResults = searchable
                    this.fetchPresetVotes()
                    return
                }
                let fuseOptions = {
                    caseSensitive: false,
                    tokenize: true,
                    shouldSort: true,
                    threshold: 0.4,
                    keys: ['abnormalitySearchable', 'panel.name'],
                }
                var fuse = new Fuse(searchable, fuseOptions)
                this.searchResults = fuse.search(this.presetSearchTerms)
                this.fetchPresetVotes()
            },
            fetchPanelPresets: function(update){
                if(this.panelPresets[this.presetCategory] && !update){
                    this.searchPresets()
                    return
                } 
                let api_url = this.$store.state.api_url + "/api/panelPresets/" + (this.presetCategory == "personal" ? "myPresets" : "publicPresets")
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                    if(!data) data = []
                    this.panelPresets[this.presetCategory] = data.reduce(function(presetLookup, presetEntry) {
                        presetEntry.abnormalitySearchable = presetEntry.abnormality ? presetEntry.abnormality : "normal"
                        presetLookup[presetEntry.id] = presetEntry;
                        return presetLookup;
                    }, {});
                    this.searchPresets()
                }).catch(() => {
                    this.$emit("notify", "Failed to fetch panel presets.")
                })
            },
            fetchPresetVotes: function(){
                this.searchResults.forEach((presetEntry) => {
                    if(!this.presetVotes[presetEntry.id]){
                        let api_url = this.$store.state.api_url + "/api/vote/panel_preset/" + presetEntry.id + "/"
                        APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                            let voteEntry = {
                                myVote: data.myVote && data.myVote.vote ? data.myVote.vote : "",
                                counts: {
                                    "up": data.counts["up"] ? data.counts["up"] - (this.currentVote == "up") : 0,
                                    "down": data.counts["down"] ? data.counts["down"] - (this.currentVote == "down") : 0
                                }
                            }
                            this.$set(this.presetVotes, presetEntry.id, voteEntry)
                        })
                    }
                })
            },

            addPresetsToSlide: function(){
                let presetsToAdd = this.presetsToAdd.map((presetID) => {
                    let presetData = this.panelPresets[this.presetCategory][presetID].panel
                    presetData.id = ObjectID().toString()
                    return presetData
                })
                this.$emit("addPresetsToSlide", presetsToAdd)
            },
            createNewPreset: function(){
                let confirm_msg = "Are you sure you want to create a new lab preset?"
                if(!confirm(confirm_msg)) return
                let presetData = {
                    description: "",
                    abnormality: "",
                    panel: {
                        id: ObjectID().toString(),
                        info: {
                            order: 0, 
                            resources: []
                        },
                    }
                }
                let api_url = this.$store.state.api_url + "/api/panelPresets/update"
                APIRequests.postJSONData(api_url, presetData, this.$store.state.jwtToken).then((data) => {
                    if(!data) data = {}
                    if(!data.presetID) throw "Missing preset ID in response from server"
                    this.$router.push("?presetID=" + data.presetID)
                    this.fetchPanelPresets(true)
                }).catch(() => {
                    this.$emit("notify", "Failed to save panel preset.")
                })
            },
        },
        mounted: function(){
            this.$nextTick(function(){
                this.fetchPanelPresets()
            })
        }
    }
</script>

<style scoped>
    .active-vote{ 
        color: #448aff;
    }
    .md-checkbox{
        margin: 16px;
    }
</style>